// extracted by mini-css-extract-plugin
module.exports = {"header":"_a7d04b1","button":"_d4165ee","tickIcon":"_edcc8ab","closeIcon":"_8f194aa"};